import axios from 'axios'
import {baseUrl} from '../config'
import {IData} from '../../types/data'

export function getData(electionId: number, candidateId: number | string): Promise<IData> {
  return axios.get(`${baseUrl}/${candidateId}/election/${electionId}/data`).then(response => response.data)
}

export function getCandidateQuestions(electionId: number, candidateId: number | string): any {
  return axios.get(`${baseUrl}/${candidateId}/election/${electionId}/questions`).then(response => response.data)
}
